import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@mui/styles";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import download from '../images/download-doc.svg';
import "react-daterange-picker/dist/css/react-calendar.css";
import Divider from '@mui/material/Divider';
import spinner from '../../assign-prescriptions/images/spinner.gif';
import Typography from "@mui/material/Typography";
import {Grid, IconButton} from "@mui/material";
import {Box} from "@mui/system";
import moment from 'moment-timezone';
import {withTranslation} from "react-i18next";
import ILocalAGGrid, {
  getDefaultColDef,
  createServerSideDatasource,
  withDateColumnFilter,
  applyReportFilterModel,
  attachReportServerSideDatasource,
} from "../../grid/iLocalAGGrid";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import {getDefaultDateRange, getDateRangeByPreset, formatFromDateForAPI, formatToDateForAPI} from "../../../utils/datetime.utils";

function TabContainer({ children, dir, classes }) {
    return (
        <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
            {children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
    dir: PropTypes.string.isRequired,
};

class EnhancedTableHead extends React.Component {
    createSortHandler = (property, field) => event => {
        this.props.onRequestSort(event, property, field);
    };

    render() {
        const {order, orderBy, sortId, t} = this.props;
        const rows = [
            { id: "MemberId", numeric: false, disablePadding: false, label: t('Report.Loyalty.MemberOrLoyaltyNumber'), padding: '10px', field: 'member_number' },
            { id: "IDNumber", numeric: false, disablePadding: false, label: t("Report.Loyalty.IDNumber"), padding: '10px', field: 'id_number' },
            { id: "FirstName", numeric: false, disablePadding: false, label: t("Report.Loyalty.FirstName"), padding: '10px', field: 'first_name' },
            { id: "LastName", numeric: false, disablePadding: false, label: t("Report.Loyalty.LastName"), padding: '10px', field: 'last_name' },
            { id: "Store", numeric: false, disablePadding: false, label: t("Report.Loyalty.Store"), padding: '10px', field: 'name' },
            { id: "Box", numeric: false, disablePadding: false, label: t("Report.Loyalty.Box"), padding: '10px', field: 'name' },
            { id: "Phone", numeric: false, disablePadding: false, label: t("Report.Loyalty.Phone"), padding: '10px', field: 'smsphone' },
            { id: "email", numeric: false, disablePadding: false, label: t("Report.Loyalty.Email"), padding: '10px', field: 'email' },
            { id: "dob", numeric: false, disablePadding: false, label: t("Report.Loyalty.DateOfBirth"), padding: '10px', field: 'dob_str' },
            { id: "enroll_date", numeric: false, disablePadding: false, label: t("Report.Loyalty.EnrollDateTime"), padding: '10px', field: 'created_on' },
        ];

        return (
            <TableHead>
                <TableRow>
                    {rows.map(row => {
                        return (
                            <TableCell
                                key={row.id}
                                numeric={row.numeric}
                                padding={row.disablePadding ? "none" : "default"}
                                sortDirection={orderBy === row.id ? order : false}
                                style={{ padding: row.padding, color: 'rgba(0, 0, 0, 0.54)' }}
                            >
                                {['MemberId', 'IDNumber', 'Store', 'Phone'].includes(row.id) ?
                                    (
                                        <TableSortLabel style={{ cursor: 'text' }}>
                                            {row.label}
                                        </TableSortLabel>
                                    ) : (
                                        <Tooltip
                                            title={t("Global.Label.Filter.Sort")}
                                            placement={row.numeric ? "bottom-end" : "bottom-start"}
                                            enterDelay={300}
                                        >
                                            <TableSortLabel
                                                active={orderBy === row.field && sortId === row.id}
                                                direction={order}
                                                onClick={this.createSortHandler(row.id, row.field)}
                                            >
                                                {row.label}
                                            </TableSortLabel>
                                        </Tooltip>
                                    )
                                }
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const styles = theme => ({
    root: {
        width: "100%",
    },
    table: {
        minWidth: 1020
    },
    tableWrapper: {
        overflowX: "auto"
    },
    dob: {
        paddingTop: '25px',
    },
    headerdiv: {
        paddingLeft: '15%',
        paddingTop: '10'
    },
    padding10px: {
        padding: '10px'
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        maxWidth: 390,
    },
    logoWrapper:
    {
        position: 'absolute',
        width: '89%',
        height: '70%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'rgba(255,255,255,0.5)',
        zIndex: '7869'
    },
    spinner: {
        position: 'absolute',
        background: 'rgba(255,255,255,.4)',
        width: '100%',
        height: '100%',
        zIndex: '9999',
        top: 0,
        left: 0,
    },
    spinnerImage: {
        top: 'calc(50% - 32.5px)',
        left: 'calc(50% - 65px)',
        position: 'absolute',
        width: '130px',
        userSelect: 'none'
    },
    hidden: {
        display: 'none'
    },
    rowheight: {
        height: '35px'
    }
});

const __reportDefaultDates = getDefaultDateRange();

let LoyaltyMembersFilterObj = {
  searchObject: null,
    store_ids: [],
    box_ids: [],
    searchtext: '',
    fromdate: formatFromDateForAPI(__reportDefaultDates.fromDate),
    todate: formatToDateForAPI(__reportDefaultDates.toDate),
    pageNo: 0,
    pageSize: 10,
    sortOrder: 'desc',
    sortColumn: 'created_on',
    tableName: '',
    group_id: null
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            order: "desc",
            dob: '',
            orderBy: "created_on",
            page: 0,
            rowsPerPage: 10,
            searchtext: '',
            store_id: [],
            box_id: [],
            fromdate: null,
            todate: null,
            dateRangePreset: 'last7days',
            isOpen: false,
            stores: [],
            boxes: [],
            boxvalues: [],
            accountValues: [],
            nstores: [],
            nboxes: [],
            chipstores: [],
            chipboxes: [],
            loader: false,
            selectedObject: null,
            isDataEmpty: true,
            selectedTab: 0,
            tempThresholds: [],
            totalRecords: 0,
            isButtonDisabled: false,
            locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
            queryId: "",
            groups: [],
        };
        this.handleStoreChange = this.handleStoreChange.bind(this);
        this.handleBoxChange = this.handleBoxChange.bind(this);
        this.debouceTimeout = null;
    }

  
  refreshGrid = () => {
    if (!this.gridApi) return;
    if (typeof this.gridApi.refreshServerSideStore === "function") {
      this.gridApi.refreshServerSideStore({ purge: true });
    } else if (typeof this.gridApi.refreshServerSide === "function") {
      this.gridApi.refreshServerSide({ purge: true });
    }
  };

  onPaginationChanged = (params) => {
    if (!params.api) return;
    const newPageSize = params.api.paginationGetPageSize();
    if (newPageSize && LoyaltyMembersFilterObj.pageSize !== newPageSize) {
      LoyaltyMembersFilterObj.pageSize = newPageSize;
    }
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    const datasource = createServerSideDatasource({
      filterBody: LoyaltyMembersFilterObj,
      applyFilterModel: (body, filterModel) => {
        applyReportFilterModel(body, filterModel, { dateColIds: ['enroll_date'] });
      },
      pageZeroBased: true,
      getPageSize: () => LoyaltyMembersFilterObj.pageSize || 10,
      fetchPage: (body) =>
        fetch(process.env.REACT_APP_BASEURL + "loyalty-members", {
          method: "post",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data && data.results) return data;
            if (data && data.data && data.data.results) {
              return { results: data.data.results, total: data.data.total };
            }
            if (Array.isArray(data)) return { results: data, total: data.length };
            return {
              results: (data && (data.rows || data.data)) || [],
              total: (data && data.total) || 0,
            };
          }),
      onSuccess: (results, total) => {
        this.setState({
          data: results,
          totalRecords: total,
          loader: false,
          isDataEmpty: !results || results.length === 0,
        });
      },
      onError: () => this.setState({ loader: false }),
    });
    attachReportServerSideDatasource(params, datasource, LoyaltyMembersFilterObj, 'enroll_date');
  };

  componentDidMount() {
        LoyaltyMembersFilterObj.group_id = sessionStorage.getItem("groupID")
        this.setState({ loader: true });
        fetch(process.env.REACT_APP_BASEURL + "accounts", {
            method: 'GET',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            }
        }).then(response => response.json()).then(accounts => {
            let All = [{ id: "-1", name: "All" }]
            const storelist = accounts.map(account => {
                return { id: account.id, name: account.name };
            });

            const accountValues = All.concat(storelist);
            this.setState({ accountValues, parent_account_id: accountValues[0].id });
            this.BindBoxesbyStoreId(storelist.map(x => x.id));
            this.setState({ loader: false });
        });
        // Set default date range (T-30 days to today)
        const defaultDates = getDefaultDateRange();
        this.setState({ 
            fromdate: defaultDates.fromDate,
            todate: defaultDates.toDate,
            dateRangePreset: 'last7days'
        });

        Object.assign(LoyaltyMembersFilterObj, {
            store_ids: [],
            box_ids: [],
            searchtext: '',
            fromdate: formatFromDateForAPI(defaultDates.fromDate),
            todate: formatToDateForAPI(defaultDates.toDate),
            pageNo: 0,
            pageSize: 10,
            sortOrder: 'desc',
            sortColumn: 'created_on',
            tableName: ''});
        this.fetchSuggestions();
        this.setState({ loader: false });
    }

    convertToTimeZone = (requestDate) => {
        const currentUserLang = localStorage.getItem('i18nextLng');
        let zone;
        zone = sessionStorage.getItem('timeZone');
        const date = moment(new Date(requestDate));
        if (['null', null, 'undefined', undefined].includes(zone)) {
            zone = defaultZone;
        }
        return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
    }

    exportCSV() {
        this.setState({ loader: true });
        fetch(process.env.REACT_APP_BASEURL + 'CSV/LoyaltyMemberReport', {
            method: 'POST',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(LoyaltyMembersFilterObj)
        })
            .then(response => {
                try {
                    return response.json();
                } catch (error) {
                    return null;
                }
            })
            .then(csvData => {
                this.setState({ loader: false });
                let csvRow = [];
                let Array = [['Id', 'MemberId', 'IDNumber', 'FirstName', 'LastName', 'Store', 'Box', 'Phone', 'email', 'dob', 'Enroll Date/Time']];
                let result = csvData && csvData.Results && csvData.Results.length > 0 ? csvData.Results : [];
                if (result !== undefined && result !== 'undefined') {
                    if (result && result.length > 0) {
                        for (let i of result) {
                            Array.push(
                                [
                                    i.member_number,
                                    i.id_number,
                                    i.firstname,
                                    i.lastname,
                                    i.store,
                                    i.box,
                                    i.smsphone,
                                    i.email,
                                    i.dob_str,
                                    i.created_on ? this.convertToTimeZone(i && i.created_on) : '',
                                ]
                            );
                        }

                        for (let i of Array) {
                            csvRow.push(i.join(","));
                        }
                        let csvString = csvRow.join("%0A");
                        let element = document.createElement("a");
                        element.href = 'data:attachment/csv.' + csvString;
                        element.target = "_Blank";
                        element.download = "LoyaltyMembersReport.csv";
                        document.body.appendChild(element);
                        element.click();
                    }
                }
            })
    }

    gettingOnSortTableName = (field) => {
        let tablename = '';
        if (['MemberId', 'FirstName', 'LastName', 'Phone', 'email', 'enroll_date'].includes(field)) {
            tablename = 'loyalty_members';
        }
        if (['Store'].includes(field)) {
            tablename = 'accounts';
        }
        if (['Box'].includes(field)) {
            tablename = 'boxes';
        }
        return tablename;
    }

    handleRequestSort = (event, property, field) => {
        const orderBy = property;
        let order = "desc";
        if (this.state.order === "desc") {
            order = "asc";
        }
        this.setState({ order, orderBy, sortId: property });
        LoyaltyMembersFilterObj.sortOrder = order;
        LoyaltyMembersFilterObj.sortColumn = field;
        LoyaltyMembersFilterObj.tableName = this.gettingOnSortTableName(orderBy);
        
        if (this.state.data && this.state.data.length > 0) {
            this.BindGrid();
        }
    };

    handleChangePage = (event, page) => {
        event && event.preventDefault();
        
        LoyaltyMembersFilterObj.pageNo = page;
        if (this.state.data && this.state.data.length > 0) {
            this.BindGrid();
        }
    };

    handleChangeRowsPerPage = event => {
        
        LoyaltyMembersFilterObj.pageNo = 0;
        LoyaltyMembersFilterObj.pageSize = event.target.value;
        if (this.state.data && this.state.data.length > 0) {
            this.BindGrid();
        }
    };

    //Bind Boxes by store id
    BindBoxesbyStoreId(store_ids) {
        if (store_ids.length > 0) {
            this.setState({ loader: true });
            let BoxesObj = {
                store_ids: store_ids
            }
            fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
                method: 'post',
                withCredentials: true,
                headers: {
                    'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(BoxesObj)
            }).then(response => {
                try {
                    return response.json();
                } catch (error) {
                    return null;
                }
            }).then(data => {
                let All = [{ id: "-1", name: "All" }]
                const boxlist = data.map(account => {
                    return { id: account.id, name: account.name };
                });
                const boxvalues = All.concat(boxlist);
                this.setState({ chipboxes: [] });
                this.setState({ nboxes: [] });
                this.setState({ boxvalues: boxvalues });
                this.setState({ loader: false });
            });
        }
    }

    handleStoreChange = event => {
        const storeid = event.target.value;
        const storeids = [];
        let processed = [];
        let chipprocessed = [];
        const AllprocessedIndex = storeid.findIndex(x => x.id === '-1');
        
        if (AllprocessedIndex > -1) {
            chipprocessed = [this.state.accountValues[0]];
            for (let i = 0; i < this.state.accountValues.length; i++) {
                processed.push(this.state.accountValues[i]);
            }
        }
        else if (storeid.length === 0) {
            chipprocessed = [];
            processed = [];
        }
        else if (storeid.length > 0) {
            for (let i = 0; i < event.target.value.length; i++) {
                const element = event.target.value[i];
                if (element.id !== '-1') {
                    chipprocessed.push(element);
                    processed.push(element);
                }
            }
        }
        
        this.setState({ chipstores: chipprocessed });
        this.setState({ nstores: processed });

        if (processed.length > 0) {
            for (let i = 0; i < processed.length; i++) {
                if (processed[i].id !== '-1') {
                    storeids.push(processed[i].id)
                }
            }
        }
        this.setState({ store_id: storeids });
        LoyaltyMembersFilterObj.store_ids = storeids;
        LoyaltyMembersFilterObj.pageNo = 0;
        LoyaltyMembersFilterObj.sortOrder = 'desc';
        LoyaltyMembersFilterObj.sortColumn = 'created_on';
        LoyaltyMembersFilterObj.tableName = '';
        this.BindBoxesbyStoreId(storeids);

        this.BindGrid();
    };

    handleBoxChange = event => {
        const boxid = event.target.value;
        const boxids = [];

        let processed = [];
        let chipprocessed = [];
        const AllprocessedIndex = boxid.findIndex(x => x.id === '-1');
        
        if (AllprocessedIndex > -1) {
            chipprocessed = [this.state.boxvalues[0]];
            for (let i = 0; i < this.state.boxvalues.length; i++) {
                processed.push(this.state.boxvalues[i]);
            }
        }
        else if (boxid.length === 0) {
            chipprocessed = [];
            processed = [];
        }
        else if (boxid.length > 0) {
            for (let i = 0; i < event.target.value.length; i++) {
                const element = event.target.value[i];
                if (element.id !== '-1') {
                    chipprocessed.push(element);
                    processed.push(element);
                }
            }
        }
        
        this.setState({ chipboxes: chipprocessed });
        this.setState({ nboxes: processed });
        if (processed.length > 0) {
            for (let i = 0; i < processed.length; i++) {
                if (processed[i].id !== '-1') {
                    boxids.push(processed[i].id)
                }
            }
        }
        this.setState({ box_id: boxids });
        LoyaltyMembersFilterObj.box_ids = boxids;
        LoyaltyMembersFilterObj.pageNo = 0;
        LoyaltyMembersFilterObj.sortOrder = 'desc';
        LoyaltyMembersFilterObj.sortColumn = 'created_on';
        LoyaltyMembersFilterObj.tableName = '';
        this.BindGrid();
    };

    handleDeleteStoreChip = (chipToDelete) => (event) => {
        if (event && event.stopPropagation) {
            event.stopPropagation();
        }
        if (chipToDelete.id === '-1') {
            this.setState({ chipstores: [], nstores: [], store_id: [] });
            LoyaltyMembersFilterObj.store_ids = [];
            LoyaltyMembersFilterObj.pageNo = 0;
            this.BindBoxesbyStoreId([]);
            this.BindGrid();
            return;
        }
        const updatedStores = this.state.chipstores.filter(chip => chip.id !== chipToDelete.id);
        const updatedNStores = this.state.nstores.filter(store => store.id !== chipToDelete.id);
        this.setState({ chipstores: updatedStores, nstores: updatedNStores });
        const storeids = updatedNStores.filter(s => s.id !== '-1').map(s => s.id);
        this.BindBoxesbyStoreId(storeids);
        LoyaltyMembersFilterObj.store_ids = storeids;
        LoyaltyMembersFilterObj.pageNo = 0;
        this.BindGrid();
    };

    handleDeleteBoxChip = (chipToDelete) => (event) => {
        if (event && event.stopPropagation) {
            event.stopPropagation();
        }
        if (chipToDelete.id === '-1') {
            this.setState({ chipboxes: [], nboxes: [], box_id: [] });
            LoyaltyMembersFilterObj.box_ids = [];
            LoyaltyMembersFilterObj.pageNo = 0;
            this.BindGrid();
            return;
        }
        const updatedBoxes = this.state.chipboxes.filter(chip => chip.id !== chipToDelete.id);
        const updatedNBoxes = this.state.nboxes.filter(box => box.id !== chipToDelete.id);
        this.setState({ chipboxes: updatedBoxes, nboxes: updatedNBoxes });
        const boxids = updatedNBoxes.filter(b => b.id !== '-1').map(b => b.id);
        LoyaltyMembersFilterObj.box_ids = boxids;
        LoyaltyMembersFilterObj.pageNo = 0;
        this.BindGrid();
    };

    handleClearAllStores = (event) => {
        if (event && event.stopPropagation) {
            event.stopPropagation();
        }
        this.setState({ chipstores: [], nstores: [], store_id: [] });
        LoyaltyMembersFilterObj.store_ids = [];
        LoyaltyMembersFilterObj.pageNo = 0;
        this.BindBoxesbyStoreId([]);
        this.BindGrid();
    };

    handleClearAllBoxes = (event) => {
        if (event && event.stopPropagation) {
            event.stopPropagation();
        }
        this.setState({ chipboxes: [], nboxes: [], box_id: [] });
        LoyaltyMembersFilterObj.box_ids = [];
        LoyaltyMembersFilterObj.pageNo = 0;
        this.BindGrid();
    };

    //Search Text Box change event
    onSearchChange = (event) => {
        this.debouceTimeout && clearInterval(this.debouceTimeout);
        const searchString = event.target.value;
        this.setState({ searchtext: searchString && searchString });
        LoyaltyMembersFilterObj.pageNo = 0;
        LoyaltyMembersFilterObj.sortOrder = 'desc';
        LoyaltyMembersFilterObj.sortColumn = 'created_on';
        LoyaltyMembersFilterObj.tableName = '';
        LoyaltyMembersFilterObj.searchtext = searchString;
        this.debouceTimeout = setTimeout(() => {
            this.BindGrid();
        }, 1000)
    }

    onFromDateSelect = date => {
        const dateObj = date ? moment(date) : null;
        this.setState({ fromdate: dateObj, dateRangePreset: '' });
        LoyaltyMembersFilterObj.pageNo = 0;
        LoyaltyMembersFilterObj.sortOrder = 'desc';
        LoyaltyMembersFilterObj.sortColumn = 'created_on';
        LoyaltyMembersFilterObj.tableName = '';
        LoyaltyMembersFilterObj.fromdate = formatFromDateForAPI(dateObj);
        this.BindGrid();
    };

    onToDateSelect = date => {
        const dateObj = date ? moment(date) : null;
        this.setState({ todate: dateObj, dateRangePreset: '' });
        LoyaltyMembersFilterObj.pageNo = 0;
        LoyaltyMembersFilterObj.sortOrder = 'desc';
        LoyaltyMembersFilterObj.sortColumn = 'created_on';
        LoyaltyMembersFilterObj.tableName = '';
        LoyaltyMembersFilterObj.todate = formatToDateForAPI(dateObj);
        this.BindGrid();
    };

    handleBlurfrom = (value, date) => {
        const dateObj = date ? moment(date) : null;
        this.setState({
            fromdate: dateObj,
            dateRangePreset: ''
        });
        LoyaltyMembersFilterObj.pageNo = 0;
        LoyaltyMembersFilterObj.sortOrder = 'desc';
        LoyaltyMembersFilterObj.sortColumn = 'created_on';
        LoyaltyMembersFilterObj.tableName = '';
        LoyaltyMembersFilterObj.fromdate = formatFromDateForAPI(dateObj);
        this.BindGrid();
    }
    handleBlurtodate = (value, date) => {
        const dateObj = date ? moment(date) : null;
        this.setState({
            todate: dateObj,
            dateRangePreset: ''
        });
        LoyaltyMembersFilterObj.pageNo = 0;
        LoyaltyMembersFilterObj.sortOrder = 'desc';
        LoyaltyMembersFilterObj.sortColumn = 'created_on';
        LoyaltyMembersFilterObj.tableName = '';
        LoyaltyMembersFilterObj.todate = formatToDateForAPI(dateObj);
        this.BindGrid();
    }
    
    handleDateRangePresetChange = (event) => {
        const preset = event.target.value;
        if (!preset) return;
        
        const dateRange = getDateRangeByPreset(preset);
        this.setState({
            fromdate: dateRange.fromDate,
            todate: dateRange.toDate,
            dateRangePreset: preset
        });
        
        LoyaltyMembersFilterObj.pageNo = 0;
        LoyaltyMembersFilterObj.sortOrder = 'desc';
        LoyaltyMembersFilterObj.sortColumn = 'created_on';
        LoyaltyMembersFilterObj.tableName = '';
        LoyaltyMembersFilterObj.fromdate = formatFromDateForAPI(dateRange.fromDate);
        LoyaltyMembersFilterObj.todate = formatToDateForAPI(dateRange.toDate);
        this.BindGrid();
    };

    BindGrid = () => {
      if (this.gridApi) {
        this.refreshGrid();
        return;
      }
      // SSRM datasource is attached in onGridReady; avoid a parallel
      // legacy fetch/setState race that leaves the grid on Please Wait...
      this.setState({ loader: false });
    };

    handleInputChange = (event) => {
        this.setState({ queryId: event.target.value });
        LoyaltyMembersFilterObj.group_id = event.target.value
        this.BindGrid();
    };

    fetchSuggestions = async () => {
        try {
            const result = fetch(`${process.env.REACT_APP_BASEURL}groups/search`, {
                method: "GET",
                withCredentials: true,
                headers: {
                    Authorization:
                        "Bearer " +
                        JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
                            .jwtToken,
                    "Content-Type": "application/json",
                },
            }
            );
            result
                .then((result) => {
                    result.json().then((resLocation) => {
                        this.setState({ groups: resLocation && resLocation.data })
                    })
                })
        } catch (error) {
            console.error("Error fetching groups:", error);
        }
    };

    render() {
        const {classes, t} = this.props;
        return (
            <Paper id="react-no-print" className={classes.root}>
                {
                    this.state.loader ?
                        <div className={classes.spinner}>
                            <img className={classes.spinnerImage} src={spinner} alt="loading" />
                        </div> :
                        null
                }
                <div id="react-no-print">
                                        <Box component="div">
                      <Grid container direction={'row'} alignItems={'center'} justifyContent={'flex-end'} spacing={2} sx={{ mt: 0, ml: 0, width: '100%', p: '0% 2% 1%' }}>
                        <Grid item xs={12} md={12} sx={{ textAlign: 'end' }}>
                          <Tooltip key="single-edit" title={t("Report.Loyalty.ExportCSVTooltip")}>
                                                              <IconButton
                                                                  style={{ marginRight: '0' }}
                                                                  aria-label="ExportCSV"
                                                                  disabled={this.state.isButtonDisabled}
                                                              >
                                                                  <img alt="download" onClick={() => { this.exportCSV() }} src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                                                              </IconButton>
                                                          </Tooltip>
                        </Grid>
                      </Grid>
                    </Box>
                </div>
                <Divider style={{ marginTop: '10px', height: '5px' }} />
                <div className={classes.tableWrapper}>
                    <ILocalAGGrid
            columnDefs={[
              { field: 'member_number', headerName: t('Report.Loyalty.MemberOrLoyaltyNumber'), colId: 'MemberId' },
              { field: 'id_number', headerName: t("Report.Loyalty.IDNumber"), colId: 'IDNumber' },
              { field: 'firstname', headerName: t("Report.Loyalty.FirstName"), colId: 'FirstName' },
              { field: 'lastname', headerName: t("Report.Loyalty.LastName"), colId: 'LastName' },
              { field: 'store', headerName: t("Report.Loyalty.Store"), colId: 'Store' },
              { field: 'box', headerName: t("Report.Loyalty.Box"), colId: 'Box' },
              { field: 'smsphone', headerName: t("Report.Loyalty.Phone"), colId: 'Phone' },
              { field: 'email', headerName: t("Report.Loyalty.Email"), colId: 'email' },
              { field: 'dob_str', headerName: t("Report.Loyalty.DateOfBirth"), colId: 'dob' },
              withDateColumnFilter({ field: 'created_on', headerName: t("Report.Loyalty.EnrollDateTime"), colId: 'enroll_date', valueFormatter: (p) => p.value ? this.convertToTimeZone(p.value) : '' }),
            ]}
            defaultColDef={getDefaultColDef()}
            rowModelType="serverSide"
            cacheBlockSize={LoyaltyMembersFilterObj.pageSize || 10}
            paginationPageSize={LoyaltyMembersFilterObj.pageSize || 10}
            paginationPageSizeSelector={[10, 20, 25]}
            rowHeight={40}
            getRowId={(params) =>
              (params.data && (params.data.prescription_txn_id || params.data.id || params.data.pmid || params.data.uuid)) ||
              String(params.data && JSON.stringify(params.data).slice(0,40))
            }
            onGridReady={this.onGridReady}
            onPaginationChanged={this.onPaginationChanged}
          />
        </div>
            </Paper>
        );
    }
}

EnhancedTable.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/loyalty-members/index.js